/**
 * CategoryCardItem - Individual category card
 *
 * Features:
 * - Image with hover zoom effect
 * - Title below image
 * - Links to category URL or custom link
 * - Responsive height matching product cards
 */

import { useCategoryCardsVariants } from '../../../Theme'

import type { HomepageCategoryCard } from '../../types'

interface CategoryCardItemProps {
  card: HomepageCategoryCard
  /** Resolved URL for category link type */
  resolvedUrl: string | undefined
}

export function CategoryCardItem({ card, resolvedUrl }: CategoryCardItemProps) {
  const {
    categoryCardItemVariants,
    categoryCardImageWrapperVariants,
    categoryCardImageVariants,
    categoryCardTitleVariants,
  } = useCategoryCardsVariants()

  // Determine the href based on link type
  // For 'category': resolvedUrl is already a full path (e.g. "/rochii.html") from useCategoryUrls
  // For 'custom_link': use link_value directly (admin sets full URL like "/promotii")
  const href =
    card.link_type === 'category'
      ? resolvedUrl || undefined
      : card.link_value || undefined

  if (!href) return null

  return (
    <a
      href={href}
      className={categoryCardItemVariants()}
    >
      {/* Image */}
      <div className={categoryCardImageWrapperVariants()}>
        {card.image ? (
          <img
            src={card.image}
            alt={card.title || ''}
            width={500}
            height={600}
            className={categoryCardImageVariants()}
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full bg-gray-100 flex items-center justify-center">
            <span className="text-gray-400 text-sm">No image</span>
          </div>
        )}
      </div>

      {/* Title */}
      {card.title && (
        <div className={categoryCardTitleVariants()}>
          {card.title}
        </div>
      )}
    </a>
  )
}
